import React from 'react';
import { Shield, CheckCircle2 } from 'lucide-react';
export function Guarantee() {
  return <section className="py-16 md:py-20 px-4 bg-slate-50 border-y border-slate-200" data-id="element-179">
      <div className="max-w-3xl mx-auto text-center" data-id="element-180">
        <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-primary/10 border-2 border-primary mb-6 shadow-[0_10px_30px_rgba(37,99,235,0.15)]" data-id="element-181">
          <Shield className="w-10 h-10 text-primary" data-id="element-182" />
        </div>

        <p className="text-primary font-bold uppercase tracking-widest text-[11px] md:text-sm mb-3" data-id="element-183">
          🛡️ Sin riesgo · 100% garantizado
        </p>

        <h2 className="text-2xl md:text-4xl font-extrabold mb-6 leading-tight text-slate-900" data-id="element-184">
          Probalo 7 días. Si no te sirve,
          <br data-id="element-185" />
          <span className="text-primary" data-id="element-186">te devolvemos el 100%.</span>
        </h2>

        <div className="bg-white border border-slate-200 shadow-sm rounded-2xl p-6 md:p-8 text-left space-y-4 text-base md:text-lg text-slate-600 leading-relaxed font-medium" data-id="element-187">
          <p data-id="element-188">
            Abrís los tomos.{' '}
            <span className="text-slate-900 font-bold" data-id="element-189">
              Los usás en el aula.
            </span>
          </p>
          <p data-id="element-190">
            Y si en 7 días sentís que no era lo que esperabas, te devolvemos el
            dinero.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 pt-2" data-id="element-191">
            <div className="flex items-center gap-2 text-slate-900 font-bold text-sm md:text-base" data-id="element-192">
              <CheckCircle2 className="w-5 h-5 text-primary shrink-0" data-id="element-193" />
              Sin vueltas
            </div>
            <div className="flex items-center gap-2 text-slate-900 font-bold text-sm md:text-base" data-id="element-194">
              <CheckCircle2 className="w-5 h-5 text-primary shrink-0" data-id="element-195" />
              Sin formularios eternos
            </div>
            <div className="flex items-center gap-2 text-slate-900 font-bold text-sm md:text-base" data-id="element-196">
              <CheckCircle2 className="w-5 h-5 text-primary shrink-0" data-id="element-197" />
              Sin drama
            </div>
          </div>
        </div>

        <p className="text-base md:text-xl font-bold text-slate-900 mt-6" data-id="element-198">
          El riesgo no es tuyo.{' '}
          <span className="text-primary" data-id="element-199">Es nuestro.</span>
        </p>

        <p className="text-xs md:text-sm text-slate-500 mt-4 font-medium" data-id="element-200">
          Tasa de devoluciones real: menos del 1%
        </p>
      </div>
    </section>;
}